import { Box, CircularProgress, useTheme } from '@mui/material';
import { IconSparkles } from '@tabler/icons-react';

import { Typography } from '@zendesk/forethought-elements';
import { insightGradients } from 'src/constants/colors';

interface AIStudioTriggerButtonProps {
  iconPosition?: 'start' | 'end';
  isLoading?: boolean;
  label: string;
  onClick: () => void;
}

export const AIStudioTriggerButton = ({
  iconPosition = 'end',
  isLoading,
  label,
  onClick,
}: AIStudioTriggerButtonProps) => {
  const { palette } = useTheme();

  const icon = <IconSparkles color='currentColor' size={19} />;

  return (
    <Box
      component='button'
      disabled={isLoading}
      onClick={onClick}
      sx={{
        '&::after': {
          background: insightGradients[100],
          borderRadius: 'inherit',
          content: '""',
          inset: 0,
          opacity: 0,
          position: 'absolute',
          transition: 'opacity 0.7s ease',
        },
        '&:hover .trigger-content': {
          color: palette.colors.teal[800],
        },
        '&:hover::after': {
          opacity: 1,
        },
        alignItems: 'center',
        background: `linear-gradient(90deg, ${palette.colors.teal[500]} 0%, #6DBBD7 100%)`,
        border: 'none',
        borderRadius: '100px',
        cursor: 'pointer',
        display: 'flex',
        height: 34,
        justifyContent: 'center',
        overflow: 'hidden',
        padding: 0,
        position: 'relative',
        width: '100%',
      }}
      type='button'
    >
      {isLoading ? (
        <CircularProgress size={18} sx={{ color: 'white', zIndex: 1 }} />
      ) : (
        <Box
          alignItems='center'
          className='trigger-content'
          display='flex'
          gap='4px'
          sx={{
            color: 'white',
            transition: 'color 0.7s ease',
            zIndex: 1,
          }}
        >
          {iconPosition === 'start' && icon}
          <Typography color='inherit' variant='font14Bold'>
            {label}
          </Typography>
          {iconPosition === 'end' && icon}
        </Box>
      )}
    </Box>
  );
};
